import { gql } from "@apollo/client";

export const ImageFields = gql`
    fragment ImageFields on Image {
        id
        URL
        FocusPoint
        ImageSize
        AltText
    }
`;

export const LinkButtonFields = gql`
    fragment LinkButtonFields on LinkButton {
        buttonTheme
        buttonText
        buttonColour
        buttonTextColour
        buttonHoverColour
        buttonTextHoverColour
        innerURL
        outerURL
    }
`;

export const ElementFields = gql`
    fragment ElementFields on Element {
        __typename
        ... on BannerWithImage {
            id
            header
            headerColour
            subheader
            subheaderColour
            text
            textColour
            backgroundColour
            theme
            textAlignType
            isImageFirst
            isImageBlock
            buttonText
            innerURL
            outerURL
            useButtonLine
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            buttonLineColour
            trackingButtonName
            secondButtonText
            secondInnerURL
            secondOuterURL
            useSecondButtonLine
            secondButtonColour
            secondButtonTextColour
            secondButtonHoverColour
            secondButtonTextHoverColour
            secondButtonLineColour
            trackingSecondButtonName
            videoButtonText
            videoPath
            useFocusPoint
            useFocusPointPortrait
            opacity
            gradientColor
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on BannerWithFullImage {
            id
            header
            headerColour
            text
            textColour
            contentAlignment
            backgroundColour
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            theme
            secondButtonText
            secondButtonColour
            secondButtonTextColour
            secondButtonHoverColour
            secondButtonTextHoverColour
            secondInnerURL
            secondOuterURL
            videoButtonText
            videoPath
            useFocusPoint
            image: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            portraitImage: webpWithFallbackPortraitImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on BannerWithExtendedProfile {
            id
            header
            headerColour
            subheader
            subheaderColour
            endorsement
            endorsementColour
            endorser
            endorserColour
            backgroundColour
            enableNoiseEffectBackground
            bookAuthor
            authorColour
            authorBios
            authorBiosColour
            authorPhotoBackgroundColour
            extendedBackgroundColour
            enableNoiseEffectExtendedBackground
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            mainImage: webpWithFallbackMain(webp: $canRenderWebp) {
                ...ImageFields
            }
            authorPhoto: webpWithFallbackAuthor(webp: $canRenderWebp) {
                ...ImageFields
            }
            useFocusPointMain
            useFocusPointAuthor
            badges {
                badge: webpWithFallbackBadge(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on CollapseList {
            id
            listType
            autoNumbering
            header
            text
            collapseItems {
                id
                header
                text
                sortOrder
            }
        }
        ... on ContactUs {
            id
            header
            text
            hubspotFormId
            useFocusPoint
            isHeaderOnTheLeft
            isFormOnTheTop
            addresses {
                city
                address
                phoneNumber
                sortOrder
            }
            landscapeImage: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            portraitImage: webpWithFallbackPortraitImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on ContentWithImageHorizontalCards {
            id
            imageCardList {
                id
                header
                headerColour
                text
                textColour
                backgroundColour
                theme
                isImageFirst
                innerURL
                outerURL
                buttonText
                buttonColour
                buttonTextColour
                buttonHoverColour
                buttonTextHoverColour
                sortOrder
                useFocusPoint
                image: webpWithFallbackImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on ContentWithImage {
            id
            header
            headerColour
            subheader
            subheaderColour
            text
            backgroundColour
            theme
            layout
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            videoButtonText
            videoPath
            videoDisplay
            autoplay
            innerURL
            outerURL
            useFocusPoint
            image: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            video {
                id
                Filename
                AbsoluteURL
            }
        }
        ... on ContentWithImageVerticalCards {
            id
            isImageFirst
            header
            headerColour
            subheader
            subheaderColour
            verticalCardList {
                id
                title
                header
                headerColour
                backgroundColour
                layoutType
                theme
                text
                textColour
                buttonText
                buttonColour
                buttonTextColour
                buttonHoverColour
                buttonTextHoverColour
                trackingButtonName
                innerURL
                outerURL
                videoPath
                sortOrder
                useFocusPoint
                image: webpWithFallbackImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
                contentList {
                    id
                    header
                    headerColour
                    innerURL
                    outerURL
                    hubspotFormId
                    sortOrder
                }
            }
        }
        ... on ContentWithList {
            id
            header
            theme
            useFocusPoint
            isImageFirst
            image: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            contentList {
                id
                header
                innerURL
                outerURL
                hubspotFormId
                sortOrder
            }
        }
        ... on ContentWithRoundImage {
            id
            header
            subheader
            text
            image: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on DescriptionWithRichText {
            id
            header
            headerColour
            subheader
            subheaderColour
            text
            backgroundColour
            theme
        }
        ... on DescriptionWithRichTextAndImage {
            id
            header
            headerColour
            subheader
            subheaderColour
            text
            textColour
            firstCircleColour
            secondCircleColour
            theme
            useFocusPoint
            image: webpWithFallbackImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on DescriptionWithRichTextSingleColumn {
            id
            header
            text
        }
        ... on DescriptionWithSimpleText {
            id
            showDoubleQuotes
            quotesColour
            headerTag
            header
            text
            textColour
            writer
            writerColour
            statement
            statementColour
            backgroundColour
            moduleHeightType
            theme
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            useFocusPoint
            altText
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on DescriptionWithSimpleTextAndImage {
            id
            showDoubleQuotes
            quotesColour
            header
            text
            textColour
            writer
            writerColour
            backgroundColour
            theme
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            videoPath
            textBoxPosition
            textBoxWidth
            moduleHeight
            useFocusPoint
            useFocusPointPortrait
            altText
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on FullImage {
            id
            header
            subheader
            moduleHeightType
            textPosition
            theme
            innerURL
            outerURL
            useFocusPoint
            useFocusPointPortrait
            altText
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on SegmentedVideo {
            id
            themeColour
            videoItems {
                id
                title
                urlSegment
                videoURL
                sortOrder
                isWatched(userId: $userId)
                videoThumbnail(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on SingleVideo {
            id
            header
            headerColour
            subheader
            subheaderColour
            backgroundColour
            theme
            videoPath
            useFocusPoint
            trackingVideoName
            videoThumbnail: webpWithFallbackVideoThumbnail(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        ... on SliderWithFeedback {
            id
            textColour
            backgroundColour
            moduleHeight
            theme
            feedbackList {
                id
                feedback
                writer
                sortOrder
            }
        }
        ... on SliderWithImage {
            id
            header
            headerColour
            showDoubleQuotes
            quotesColour
            descriptionText
            descriptionTextColour
            writer
            writerColour
            backgroundColour
            theme
            innerURL
            outerURL
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            isImageSquare
            isImageWithoutBoxShadow
            imageList {
                id
                header
                text
                backgroundColour
                innerURL
                outerURL
                sortOrder
                useFocusPoint
                expandedCardHeader
                expandedCardSubHeader
                expandedCardText
                useFocusPointExpandedImageLandscape
                useFocusPointExpandedImagePortrait
                expandedAltText
                expandedImageLandscape: webpWithFallbackExpandedImageLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                expandedImagePortrait: webpWithFallbackExpandedImagePortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
                image: webpWithFallbackImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on SliderWithQuote {
            id
            header
            headerColour
            subheader
            subheaderColour
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            trackingButtonName
            secondButtonText
            secondButtonColour
            secondButtonTextColour
            secondButtonHoverColour
            secondButtonTextHoverColour
            secondInnerURL
            secondOuterURL
            trackingSecondButtonName
            disableCarousel
            disableGrowToFit
            quoteList {
                id
                text
                textColour
                backgroundColour
                author
            }
        }
        ... on SliderWithVideo {
            id
            videoList {
                id
                header
                videoPath
                sortOrder
                image: webpWithFallbackImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on SliderWithVideoPopup {
            id
            header
            headerColour
            subheader
            subheaderColour
            backgroundColour
            theme
            videoList {
                id
                text
                videoPath
                backgroundColour
                sortOrder
                useFocusPoint
                image: webpWithFallbackImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on SubscribeForUpdates {
            id
            header
            headerColour
            subheader
            subheaderColour
            backgroundColour
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            theme
            pinnedCountryCodes
            hubspotFormIdentifier
        }
        ... on Timeline {
            id
            header
            headerColour
            text
            textColour
            isLargeItemTitle
            removeBackgroundImage
            timelineItemList {
                id
                title
                titleColour
                useNumbering
                milestoneYear
                description
                descriptionColour
                backgroundColour
                backgroundHoverColour
                theme
                isAvatarRotate
                sortOrder
                mainImage: webpWithFallbackMainImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
                avatarImage: webpWithFallbackAvatarImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on TopBanner {
            id
            buttonText
            buttonColour
            buttonTextColour
            buttonHoverColour
            buttonTextHoverColour
            innerURL
            outerURL
            buttonTheme
            secondButtonText
            secondButtonColour
            secondButtonTextColour
            secondButtonHoverColour
            secondButtonTextHoverColour
            secondInnerURL
            secondOuterURL
            secondButtonTheme
            imageList {
                id
                sortOrder
                useFocusPoint
                useFocusPointPortrait
                altText
                linkButtons {
                    ...LinkButtonFields
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
        }
        ... on SubscriptionPlan {
            id
            header
            headerColour
            text
            textColour
            pricingCardList {
                id
                header
                headerColour
                price
                priceColour
                paymentType
                text
                textColour
                backgroundColour
                theme
                buttonText
                buttonColour
                buttonTextColour
                buttonHoverColour
                buttonTextHoverColour
                innerURL
                outerURL
                sortOrder
            }
        }
        ... on HubspotForm {
            id
            header
            hubspotFormId
        }
        ... on SubscriptionList {
            id
            name
            options {
                id
                title
                description
                tiers {
                    id
                    isIncluded
                    description
                    category {
                        id
                        name
                        backgroundColour
                    }
                }
            }
        }
        ... on StatementList {
            id
            titleText
            titleTextColour
            backgroundColour
            items {
                id
                text
                textColour
            }
        }
    }
    ${ImageFields}
    ${LinkButtonFields}
`;

export const pageMenuQuery = gql`
    query pageMenu($stage: String, $canRenderWebp: Boolean!) {
        pageMenu(stage: $stage) {
            __typename
            ... on StandardMenu {
                segment
                standardPage {
                    id
                    parentID
                    titleForFooter
                    showInMenus
                    isClickable
                    showInFooter
                    linkUrl
                    sort
                    className
                    title
                    metaDescription
                    metaTitle
                    uRLSegment
                    canonical
                    robots
                    oGType
                    oGLocale
                    twitterCard
                    socialImageUrl
                    hideSocial
                    lastEdited
                    absoluteUrl
                    extraHeadTags {
                        id
                        title
                        value
                        type
                    }
                    landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                        ...ImageFields
                    }
                }
                menuButton {
                    buttonText
                    innerURL
                    outerURL
                    cartURL
                    trackingButtonName
                    trackingLoginButtonName
                }
                selectedCountry
                userCountry
                countries {
                    id
                    code
                    name
                    useFocusPoint
                    taxRate
                    currency
                    taxLabel
                    image: webpWithFallbackImage(webp: $canRenderWebp) {
                        ...ImageFields
                    }
                }
            }
        }
    }
    ${ImageFields}
`;

const pageQuery = gql`
    query page(
        $id: String,
        $urlSegment: String!,
        $stage: String,
        $canRenderWebp: Boolean!,
        $countryCode: String,
        $userId: String
    ) {
        page(
            id: $id,
            urlSegment: $urlSegment,
            stage: $stage
        ) {
            __typename
            ... on StandardPage {
                isClickable
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                isUsingAltDesign
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                elements {
                    ...ElementFields
                }
            }
            ... on BlogListPage {
                id
                isClickable
                hideHero
                showDoubleQuotes
                doubleQuotesColour
                simpleSubheader
                simpleWriter
                themeType
                theme
                contentHeader
                contentSubheader
                contentText
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                contentImage(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
            ... on BlogPost {
                id
                isClickable
                subheader
                publishedDate
                lastEdited
                shortDescription
                content
                hideBanner
                useFocusPointBanner
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                absoluteUrl
                showButton
                buttonLabel
                buttonBackgroundColour
                buttonHoverBackgroundColour
                buttonTextColour
                buttonHubspotFormId
                buttonExternalUrl
                isNewTab
                banner: webpWithFallbackBanner(webp: $canRenderWebp) {
                    ...ImageFields
                }
                author {
                    id
                    name
                    webpWithFallbackPortrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                        ...ImageFields
                    }
                }
                relatedPosts {
                    id
                    title
                    shortDescription
                    uRLSegment
                    link
                    previewImage: webpWithFallbackPreviewImage(webp: $canRenderWebp) {
                        ...ImageFields
                    }
                }
                elements {
                    ...ElementFields
                }
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
            }
            ... on CareerPage {
                id
                isClickable
                department
                employmentType
                salary
                specificationHeader
                specification
                informationHeader
                information
                shortDescription
                description
                hubspotFormId
                externalLinkUrl
                theme
                textColour
                useFocusPoint
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                showRibbon
                cityCode {
                    id
                    name
                    countryCode {
                        id
                        name
                    }
                }
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                imagesAndVideos {
                    id
                    videoPath
                    image: webpWithFallbackImage(webp: $canRenderWebp)  {
                        ...ImageFields
                    }
                }
            }
            ... on CareerListPage {
                id
                isClickable
                altTitle
                bannerHeader
                bannerSubheader
                header
                subheader
                useFocusPoint
                useFocusPointPortrait
                fontColourForImageA
                fontColourForImageB
                altText
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
                imageA: webpWithFallbackImageA(webp: $canRenderWebp) {
                    ...ImageFields
                }
                imageB: webpWithFallbackImageB(webp: $canRenderWebp) {
                    ...ImageFields
                }
                elements {
                    ...ElementFields
                }
            }
            ... on EventPage {
                id
                isClickable
                specificationHeader
                specification
                description
                quote
                videoButtonText
                videoPath
                isShowingCart
                isShowingReviews
                information
                eventDate
                eventEndDate
                location
                textColour
                theme
                termsAndConditions
                altText
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                eventStartTime
                eventEndTime
                writer
                showRibbon
                trackingRegisterButtonName
                useCommonTime
                bannerLocationLabel
                isOnline
                eventSubSchedules {
                    startDate
                    endDate
                    startTime
                    endTime
                    sortOrder
                }
                googleScriptTags {
                    id
                    tag
                    isOnClick
                }
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                imagesAndVideos {
                    id
                    videoPath
                    image: webpWithFallbackImage(webp: $canRenderWebp) {
                        ...ImageFields
                    }
                }
                price {
                    id
                    amount
                    label
                    subLabel
                }
                cityCode {
                    id
                    name
                }
                countryCode {
                    id
                    name
                }
                registrationPage {
                    id
                    eventId
                    subheader
                    footerText
                    buttonText
                    hubspotFormId
                    uRLSegment
                    formFields {
                        id
                        label
                        code
                        isMandatoryForMainRegistrant
                        isMandatoryForSecondaryRegistrant
                        isOnConfirmationPage
                        type
                        validationRegex
                        validationMessage
                        noInputMessage
                        options {
                            id
                            name
                            label
                            code
                        }
                        subFormFields {
                            id
                            label
                            code
                            isMandatoryForMainRegistrant
                            isMandatoryForSecondaryRegistrant
                            isOnConfirmationPage
                            type
                            validationRegex
                            validationMessage
                            noInputMessage
                            activateWithValue
                            formFieldId
                            options {
                                id
                                name
                                label
                                code
                            }
                        }
                    }
                    allFormFields {
                        id
                        label
                        code
                        isMandatoryForMainRegistrant
                        isMandatoryForSecondaryRegistrant
                        isOnConfirmationPage
                        type
                        validationRegex
                        validationMessage
                        noInputMessage
                        options {
                            id
                            name
                            label
                            code
                        }
                        subFormFields {
                            id
                            label
                            code
                            isMandatoryForMainRegistrant
                            isMandatoryForSecondaryRegistrant
                            isOnConfirmationPage
                            type
                            validationRegex
                            validationMessage
                            noInputMessage
                            activateWithValue
                            formFieldId
                            options {
                                id
                                name
                                label
                                code
                            }
                        }
                    }
                }
                eventHubSpotRegistrationOptions {
                    buttonLabel
                    hubSpotFormID
                }
            }
            ... on EventListPage {
                id
                isClickable
                header
                subheader
                showTextOnBanner
                showButtonOnBanner
                buttonText
                useFocusPoint
                useFocusPointPortrait
                altText
                showDropdownSuitability
                showDropdownGroup
                showDropdownCountry
                showCountryOnRibbon
                showDropdownCity
                showDropdownRegion
                showDropdownMonth
                isCategorisedByTerms
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
                elements {
                    ...ElementFields
                }
            }
            ... on OnlineEventPage {
                id
                isClickable
                relatedEventPages {
                    id
                    isClickable
                    title
                    description
                    uRLSegment
                    imagesAndVideos {
                        id
                        videoPath
                        image: webpWithFallbackImage(webp: $canRenderWebp) {
                            ...ImageFields
                        }
                    }
                }
                elements {
                    ...ElementFields
                }
            }
            ... on ProductPage {
                id
                hasOnGoingDiscount
                isClickable
                specification
                description
                quote
                writer
                videoPath
                isShowingCart
                isShowingReviews
                groupName
                title
                themeColour
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                inventoryQuantity(countryCode: $countryCode)
                outOfStock(countryCode: $countryCode)
                availableForSale
                deliveryCountry
                shortDescription
                productDescription
                productType
                isUsingAltDesign
                productDisclaimer {
                    id
                    value
                }
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                imagesAndVideos {
                    id
                    title
                    sortOrder
                    useFocusPoint
                    FocusPoint
                    videoPath
                    image: webpWithFallbackImage(webp: $canRenderWebp)  {
                        ...ImageFields
                    }
                }
                price(countryCode: $countryCode) {
                    id
                    amount
                    discountedPrice
                    globalAmount
                    globalDiscountedPrice
                }
            }
            ... on ProductListPage {
                id
                isTaxIncluded
                isClickable
                useFocusPoint
                useFocusPointPortrait
                discountStartDate
                discountEndDate
                altText
                description
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                orderFormButtonLabel
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
                elements {
                    ...ElementFields
                }
            }
            ... on SuccessStoryPage {
                id
                isClickable
                specificationHeader
                specification
                descriptionHeader
                description
                quote
                videoButtonText
                videoPath
                buttonText
                innerURL
                outerURL
                schoolType
                schoolName
                groupName
                theme
                textColour
                useFocusPoint
                useFocusPointLandscape
                useFocusPointPortrait
                altText
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                writer
                shortDescription
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
                imagesAndVideos {
                    id
                    title
                    sortOrder
                    useFocusPoint
                    videoPath
                    image: webpWithFallbackImage(webp: $canRenderWebp)  {
                        ...ImageFields
                    }
                }
            }
            ... on SuccessStoryListPage {
                id
                isClickable
                header
                subheader
                showButtonOnBanner
                showHeaderOfList
                showRibbon
                useFocusPointLandscape
                useFocusPointPortrait
                buttonText
                altText
                title
                metaDescription
                metaTitle
                uRLSegment
                canonical
                manualSchema
                robots
                oGType
                oGLocale
                twitterCard
                socialImageUrl
                hideSocial
                lastEdited
                absoluteUrl
                extraHeadTags {
                    id
                    title
                    value
                    type
                }
                landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                    ...ImageFields
                }
                portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
            ... on RedirectorPage {
                id
                linkUrl
            }
        }
    }
    ${ElementFields}
    ${ImageFields}
`;

export const commonEventQuery = gql`
    query commonEvent($parentId: String!, $type: String!, $canRenderWebp: Boolean!, $countryCode: String) {
        eventMonth(parentId: $parentId, countryCode: $countryCode)
        eventMain {
            id
            title
            uRLSegment
            linkUrl
            eventDate
            regoEndDate
            useFocusPoint
            bannerHeader
            theme
            textColour
            useFocusPoint
            useFocusPointPortrait
            altText
            showRibbon
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
            cityCode {
                id
                name
            }
        }
        eventGroup(parentId: $parentId, countryCode: $countryCode) {
            id
            name
        }
        schoolType(type: $type, parentId: $parentId, countryCode: $countryCode) {
            id
            type
        }
        eventCountryCode(parentId: $parentId, countryCode: $countryCode) {
            id
            name
            code
        }
        eventCityCode(parentId: $parentId, countryCode: $countryCode) {
            id
            name
        }
        eventRegion(parentId: $parentId, countryCode: $countryCode) {
            id
            name
        }
    }
    ${ImageFields}
`;

export const eventListQuery = gql`
    query eventList(
        $parentId: String!,
        $countryCode: String!,
        $suitabilities: [String],
        $eventId: String,
        $month: String,
        $cityCodeId: String,
        $regionId: String,
        $canRenderWebp: Boolean!
    ) {
        eventList(
            parentId: $parentId,
            countryCode: $countryCode
            suitabilities: $suitabilities,
            eventId: $eventId,
            month: $month,
            cityCodeId: $cityCodeId
            regionId: $regionId
        ) {
            id
            title
            eventDate
            eventEndDate
            linkUrl
            location
            theme
            textColour
            eventStartTime
            eventEndTime
            shortDescription
            showRibbon
            eventTerm(countryCode: $countryCode)
            bannerLocationLabel
            isOnline
            previewImage: webpWithFallbackPreviewImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            price {
                id
                amount
                label
                subLabel
            }
            cityCode {
                id
                name
            }
            countryCode {
                id
                name
            }
        }
    }
    ${ImageFields}
`;

export const getEventRegistration = gql`
    query eventRegistration(
        $eventId: String,
        $userCode: String,
        $hasCheckedOut: Boolean,
    ) {
        eventRegistration(
            eventId: $eventId,
            userCode: $userCode,
            hasCheckedOut: $hasCheckedOut,
        ) {
            id
            registrants {
                id
                firstName
                lastName
                email
                customFields {
                    id
                    label
                    code
                    value
                    type
                    formFieldId
                    isOnConfirmationPage
                    optionsChosen {
                        id
                        name
                        code
                        label
                    }
                }
            }
        }
    }
`;

export const SUBMIT_EVENT_REGISTRATION_MUTATION = gql`
    mutation submitEventRegistration (
        $fields: String!,
        $eventRegistrationPageId: String!,
        $userCode: String,
        $editExistingWithId: String
    ) {
        submitEventRegistration(
            fields: $fields,
            eventRegistrationPageId: $eventRegistrationPageId,
            userCode: $userCode,
            editExistingWithId: $editExistingWithId,
        ) {
            id
            eventId
            userCode
            quantity
            registrants {
                id
            }
        }
    }
`;

export const commonProductDataQuery = gql`
    query commonProductData($type: String!, $parentId: String!) {
        productGroup {
            id
            name
        }
        productSuitability {
            id
            name
        }
        countryCode(type: $type, parentId: $parentId) {
            id
            code
            name
        }
    }
`;

export const productListQuery = gql`
    query productList(
        $parentId: String!,
        $minPriceRange: String,
        $maxPriceRange: String,
        $productGroup: String,
        $suitability: String,
        $countryCode: String,
        $sortField: String,
        $sortDirection: String,
        $canRenderWebp: Boolean!
    ) {
        productList(
            parentId: $parentId,
            minPriceRange: $minPriceRange,
            maxPriceRange: $maxPriceRange,
            productGroup: $productGroup,
            suitability: $suitability,
            countryCode: $countryCode,
            sortField: $sortField,
            sortDirection: $sortDirection
        ) {
            id
            title
            deliveryCountry
            recommended
            outOfStock(countryCode: $countryCode)
            hasOnGoingDiscount
            expectedDate
            specification
            description
            groupName
            suitabilityName
            weight
            depth
            width
            height
            inventoryQuantity(countryCode: $countryCode)
            availableForSale
            uRLSegment
            shortDescription
            productDisclaimer {
                id
                value
            }
            imagesAndVideos {
                id
                title
                sortOrder
                useFocusPoint
                videoPath
                image: webpWithFallbackImage(webp: $canRenderWebp)  {
                    ...ImageFields
                }
            }
            price(countryCode: $countryCode) {
                id
                amount
                discountedPrice
                globalAmount
                globalDiscountedPrice
            }
        }
        countryCodes {
            id
            code
            name
            currency
            taxRate
            taxLabel
            includesShippingTax
            shippingRates {
                id
                price
                maxWeight
                maxWidth
                maxDepth
                maxHeight
            }
        }
    }
    ${ImageFields}
`;

export const successStoryCommonQuery = gql`
    query successStoryCommon($type: String!, $parentId: String!, $canRenderWebp: Boolean!) {
        successStoryBanner(parentId: $parentId) {
            id
            title
            uRLSegment
            linkUrl
            useFocusPoint
            useFocusPointLandscape
            useFocusPointPortrait
            theme
            textColour
            altText
            landscape: webpWithFallbackLandscape(webp: $canRenderWebp) {
                ...ImageFields
            }
            portrait: webpWithFallbackPortrait(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
        successStoryGroup(parentId: $parentId) {
            id
            name
        }
        schoolType(type: $type, parentId: $parentId) {
            id
            type
        }
        countryCode(type: $type, parentId: $parentId) {
            id
            code
            name
        }
    }
    ${ImageFields}
`;

export const successStoryListQuery = gql`
    query successStoryList($parentId: String!, $countryCode: String, $schoolType: String, $canRenderWebp: Boolean!) {
        successStoryList(parentId: $parentId, countryCode: $countryCode, schoolType: $schoolType) {
            id
            title
            location
            linkUrl
            useFocusPoint
            textColour
            theme
            schoolType
            shortDescription
            previewImage: webpWithFallbackPreviewImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
    }
    ${ImageFields}
`;

export const careerCommonQuery = gql`
    query careerCommon($parentId: String!) {
        cityCode(parentId: $parentId) {
            id
            name
        }
    }
`;

export const careerListQuery = gql`
    query careerList($parentId: String!, $cityCodeID: String, $canRenderWebp: Boolean!) {
        careerList(parentId: $parentId, cityCodeID: $cityCodeID) {
            id
            title
            linkUrl
            department
            shortDescription
            textColour
            theme
            useFocusPoint
            showRibbon
            previewImage: webpWithFallbackPreviewImage(webp: $canRenderWebp) {
                ...ImageFields
            }
            cityCode {
                id
                name
            }
        }
    }
    ${ImageFields}
`;

export const getHomeUserQuery = gql`
    query getHomeUser {
        getHomeUser {
            id
            FirstName
            Surname
            Email
            IsEmailVerified
            IsSocialConfirmed
            HasViewedGettingStarted
            PostCode
            WhatBestDescribesYou
            LastLoginType
            StripeCustomerID
            EmailVerification {
                id
                IsValid
            }
            Subscription {
                id
                CurrentPeriodEnd
                NiceCurrentPeriodEnd
                IsValid
                Quantity
                PaymentIntent
                Price
                ProductName
                SubscriptionID
                CancelStatus
                CancelScheduleRequestedAt
                PaymentStatus
                FirstPaymentStatus
                BillingHistory {
                    id
                    InvoiceID
                    Currency
                    Amount
                    Card
                    CardType
                    Created
                    ReceiptURL
                }
            }
            BillingAddress {
                Phone
                Line
                City
                State
                CountryCode
                PostCode
            }
        }
    }
`;

export const getBlogPosts = gql`
    query blogPost($canRenderWebp: Boolean!, $parentId: String!) {
        blogPosts(parentId: $parentId) {
            id
            publishedDate
            title
            subheader
            shortDescription
            uRLSegment
            hideBanner
            useAsHero
            useFocusPointBanner
            useFocusPointListPageBanner
            useFocusPointPreview
            useCurveForBanner
            banner: webpWithFallbackListPageBanner(webp: $canRenderWebp) {
                id
                URL
                FocusPoint
                ImageSize
                AltText
            }
            author {
                id
                name
                webpWithFallbackPortrait(webp: $canRenderWebp) {
                    ...ImageFields
                }
            }
            previewImage: webpWithFallbackPreviewImage(webp: $canRenderWebp) {
                ...ImageFields
            }
        }
    }
    ${ImageFields}
`;

export const getBlogCategories = gql`
    query blogCategories {
        blogCategories {
            id
            name
            postIds
        }
    }
`;

export const CREATE_RESOURCE_ORDER = gql`
    mutation createResourceOrder (
        $paymentOption: String,
        $firstName: String!,
        $lastName: String!,
        $schoolName: String!,
        $streetNo: String!,
        $streetName: String!,
        $suburb: String!,
        $city: String!,
        $postCode: String!,
        $deliveryCountryId: String!,
        $contactEmail: String!,
        $emailToInvoice: String!,
        $orderNo: String,
        $notes: String,
        $promoCode: String,
        $discountedPrice: Float,
        $subtotal: Float,
        $shippingPrice: Float,
        $taxAmount: Float,
        $totalAmount: Float,
        $taxLabel: String,
        $taxPrefix: String,
        $currency: String,
        $orderList: [String]
    ) {
        createResourceOrder(
            paymentOption: $paymentOption,
            firstName: $firstName,
            lastName: $lastName,
            schoolName: $schoolName,
            streetNo: $streetNo,
            streetName: $streetName,
            suburb: $suburb,
            city: $city,
            postCode: $postCode,
            deliveryCountryId: $deliveryCountryId,
            contactEmail: $contactEmail,
            emailToInvoice: $emailToInvoice,
            orderNo: $orderNo,
            notes: $notes,
            promoCode: $promoCode,
            discountedPrice: $discountedPrice,
            subtotal: $subtotal,
            shippingPrice: $shippingPrice,
            taxAmount: $taxAmount,
            totalAmount: $totalAmount,
            taxPrefix: $taxPrefix,
            taxLabel: $taxLabel,
            currency: $currency,
            orderList: $orderList
        ) {
            status
        }
    }
`;

export const SUBSCRIBE_FOR_UPDATES = gql`
    mutation subscribeForUpdates(
        $hubspotFormId: String!,
        $firstName: String!,
        $lastName: String!,
        $email: String!,
        $school: String!,
        $country: String!
    ) {
        subscribeForUpdates(
            hubspotFormId: $hubspotFormId,
            firstName: $firstName,
            lastName: $lastName,
            email: $email,
            school: $school,
            country: $country,
        ) {
            status
        }
    }
`;

export const getTierCategories = gql`
    query tierCategories($parentId: String!) {
        tierCategories(parentId: $parentId) {
            id
            name
            backgroundColour
        }
    }
`;

export const getFeatureFlags = gql`
    query featureFlags {
        featureFlags
    }
`;

export const getGlobalCurrency = gql`
    query globalCurrency {
        globalCurrency {
            currency
            currencySymbol
        }
    }
`;

export const CREATE_STRIPE_PAYMENT_INTENT = gql`
    mutation createStripePaymentIntent($input: String!, $countryCode: String, $isGlobal: Boolean!) {
        createStripePaymentIntent(input: $input, countryCode: $countryCode, isGlobal: $isGlobal)
    }
`;

export const ADD_USER_DETAILS_TO_ORDER = gql`
    mutation addUserDetailsToOrder($orderUuid: String!, $input: String!) {
        addUserDetailsToOrder(orderUuid: $orderUuid, input: $input)
    }
`;

export const COMPLETE_ORDER = gql`
    mutation completeOrder($orderUuid: String!, $userId: String) {
        completeOrder(orderUuid: $orderUuid, userId: $userId)
    }
`;

export const SEND_ORDER_INVOICE = gql`
    mutation sendOrderInvoice($orderUuid: String!, $userId: String) {
        sendOrderInvoice(orderUuid: $orderUuid, userId: $userId)
    }
`;

export const VALIDATE_PRODUCT_DISCOUNT = gql`
    mutation validateProductDiscount($promoCode: String!, $countryCode: String!, $cartTotal: Float) {
        validateProductDiscount(promoCode: $promoCode, countryCode: $countryCode) {
            id
            code
            productDiscounts(countryCode: $countryCode, cartTotal: $cartTotal) {
                id
                percentDiscount
                minCartTotal
                products {
                    id
                }
            }
        }
    }
`;

export const UPDATE_OR_CREATE_CART = gql`
    mutation updateShoppingCart(
        $orderUuid: String,
        $productId: Int,
        $productQuantity: Int,
        $discountCode: String,
        $registrationId: String,
        $userCode: String,
        $isEvent: Boolean,
        $isGlobal: Boolean,
        $countryCode: String,
        $canRenderWebp: Boolean
    ) {
        updateShoppingCart(
            orderUuid: $orderUuid,
            productId: $productId,
            productQuantity: $productQuantity,
            discountCode: $discountCode,
            registrationId: $registrationId,
            userCode: $userCode,
            isEvent: $isEvent
            isGlobal: $isGlobal
            countryCode: $countryCode,
            canRenderWebp: $canRenderWebp,
        ) {
            orderUuid
            isGlobal
            taxAmount
            discountAmount
            subtotalAmount
            totalAmount
            discounts
            countryCode
            products {
                id
                quantity
                unitPrice
                discountedPrice
                totalPrice
                title
                description
                type
                productType
                totalQuantity
                registrationId
                userCode
                width
                height
                depth
                weight
                urlSegment
                isDigital
                image {
                    id
                    URL
                }
            }
        }
    }
`;

export const DELETE_CART = gql`
    mutation deleteShoppingCart($orderUuid: String!) {
        deleteShoppingCart(orderUuid: $orderUuid)
    }
`;

export const COOKIE_CATEGORIES_QUERY = gql`
    query cookieCategories {
        cookieCategories {
            id
            name
            description
            isManageable
            isAnalytics
            cookies {
                id
                name
                description
                duration
                domain
            }
        }
    }
`;

export const GET_ELIGIBLE_DISCOUNT = gql`
    query eligibleDiscount($orderCartTotal: Float!, $countryCode: String!) {
        eligibleDiscount (orderCartTotal: $orderCartTotal, countryCode: $countryCode) {
            id
            percentDiscount
            products {
                id
            }
        }
    }
`;

export const getSuggestedAddresses = gql`
    query suggestedAddresses($q: String!, $count: Int, $orderCountryCode: String!) {
        suggestedAddresses(q: $q, count: $count, orderCountryCode: $orderCountryCode) {
            address_id
            full_address
            dpid
        }
    }
`;


export const getAddress = gql`
    query address($addressId: String!, $orderCountryCode: String!) {
        address(addressId: $addressId, orderCountryCode: $orderCountryCode) {
            addressLineOne
            addressLineTwo
            buildingName
            companyName
            depotName
            floor
            ruralDeliveryNumber
            runNumber
            isGatedCommunity
            streetAlpha
            streetNumber
            streetType
            unitType
            unitValue
            street
            suburb
            city
            state
            stateShort
            country
            postCode
        }
    }
`;

export const getShippingOption = gql`
    query shippingOption(
        $orderUuid: String!,
        $orderCountryCode: String!
        $dropOffAddress: String,
        $dropOffPostcode: String,
        $dropOffState: String,
        $dropOffStateCode: String,
        $dropOffSuburb: String,
        $dropOffCountryCode: String,
        $dutiableAmount: Float,
        $returnAllQuotes: Boolean,
        $canRenderWebp: Boolean
    ) {
        shippingOption(
            orderUuid: $orderUuid,
            dropOffAddress: $dropOffAddress,
            dropOffPostcode: $dropOffPostcode,
            dropOffState: $dropOffState,
            dropOffStateCode: $dropOffStateCode,
            dropOffSuburb: $dropOffSuburb,
            dropOffCountryCode: $dropOffCountryCode,
            dutiableAmount: $dutiableAmount,
            returnAllQuotes: $returnAllQuotes,
            orderCountryCode: $orderCountryCode,
            canRenderWebp: $canRenderWebp
        ) {
            orderUuid
            taxAmount
            discountAmount
            subtotalAmount
            totalAmount
            shippingAmount
            isFreeShipping
            discounts
            countryCode
            products {
                id
                quantity
                unitPrice
                discountedPrice
                totalPrice
                title
                description
                type
                productType
                totalQuantity
                registrationId
                userCode
                width
                height
                depth
                weight
                urlSegment
                isDigital
                image {
                    id
                    URL
                }
            }
        }
    }
`;

export const REMOVE_SHIPPING_FROM_ORDER = gql`
    mutation removeShippingFromOrder($orderUuid: String!, $canRenderWebp: Boolean) {
        removeShippingFromOrder(orderUuid: $orderUuid, canRenderWebp: $canRenderWebp) {
            orderUuid
            taxAmount
            discountAmount
            subtotalAmount
            totalAmount
            discounts
            countryCode
            products {
                id
                quantity
                unitPrice
                discountedPrice
                totalPrice
                title
                description
                type
                productType
                totalQuantity
                registrationId
                userCode
                width
                height
                depth
                weight
                urlSegment
                isDigital
                image {
                    id
                    URL
                }
            }
        }
    }
`;

export const GET_CART = gql`
    query getCart($orderUuid: String, $canRenderWebp: Boolean) {
        getCart(orderUuid: $orderUuid, canRenderWebp: $canRenderWebp) {
            orderUuid
            isGlobal
            taxAmount
            discountAmount
            subtotalAmount
            totalAmount
            discounts
            countryCode
            products {
                id
                quantity
                unitPrice
                discountedPrice
                totalPrice
                title
                description
                type
                productType
                totalQuantity
                registrationId
                userCode
                width
                height
                depth
                weight
                urlSegment
                isDigital
                image {
                    id
                    URL
                }
            }
        }
    }
`;

export const GET_USER = gql`
    query getCorporateSiteUser {
        getCorporateSiteUser {
            id
            FirstName
            Surname
            Email
        }
    }
`;

export const CREATE_USER = gql`
    mutation createCorporateUser($FirstName: String!, $AuthType: String!, $Surname: String!, $Email: String!, $Password: String, $RepeatPassword: String) {
        createCorporateUser(FirstName: $FirstName, AuthType: $AuthType, Surname: $Surname, Email: $Email, Password: $Password, RepeatPassword: $RepeatPassword) {
            id
        }
    }
`;

export const SAVE_USER = gql`
    mutation saveUser($userId: String!) {
        saveUser(userId: $userId) {
            userId
        }
    }
`;

export const USER_ONLINE_VIDEO_ACTIVITY_MUTATION = gql`
    mutation updateUserOnlineVideoActivity($userId: String!, $onlineEventUrlSegment: String!, $segmentedVideoItemId: String!) {
        updateUserOnlineVideoActivity(userId: $userId, onlineEventUrlSegment: $onlineEventUrlSegment, segmentedVideoItemId: $segmentedVideoItemId) {
            status
        }
    }
`;

export default pageQuery;
